/**
 * Fantasy Console 0 - Error Display Component
 */

import { ErrorPayload } from '@fc0/types'
import { CloseIcon, ErrorIcon } from '../shared/icons'
import styles from './ErrorDisplay.module.css'

interface ErrorDisplayProps {
  error: ErrorPayload
  onDismiss: () => void
}

export function ErrorDisplay({ error, onDismiss }: ErrorDisplayProps) {
  return (
    <div className={styles.error}>
      <div className={styles.content}>
        <ErrorIcon />
        <div className={styles.message}>
          <span className={styles.label}>Error:</span>
          <span>{error.message}</span>
          {error.line && (
            <span className={styles.location}>
              Line {error.line}
              {error.column && `:${error.column}`}
            </span>
          )}
        </div>
      </div>
      <button
        className={styles.dismiss}
        onClick={onDismiss}
        aria-label='Dismiss error'
      >
        <CloseIcon size={14} />
      </button>
    </div>
  )
}
